<template>
    <div class="thousand_layout" id="VaultBuyerPanelBox" v-loading="loading">
        <div class="right_box">
            <div class="flex_layout_between">
                <h3>{{$t('vault.CardHobbyVault')}} </h3>
            </div>
        </div>
        <div v-if="vaultList&&vaultList.length>0">
        <div class="VaultedBox">
            <div style="line-height: 2;flex: 1;">
                <div class="text_2xl weight_700">{{$t('vault.Vaulted')}} <span class="text_blue">{{allList.inWarehouse.TotalCount}}</span></div>
                <div class="text_gray">{{$t('vault.TotalEstimatedValue',{n:allList.inWarehouse.UsdTotalPrice})}}</div>
            </div>
            <div>
                <router-link class="stock_btn vaultBuy" :to="{ path:'/market',query:{type:'auction',vault:1}}">{{$t('vault.BuyVaultProducts')}}</router-link>
                <router-link class="stock_btn" :to="{ path: '/vault/StockInApply' }">{{$t('vault.CardstoVault')}}</router-link>
            </div>
        </div>
            <div class="vaultBox" :style="`background-image:url(${item.BackgroundImageUrl})`" v-for="(item, index) in vaultList" :key="index">
                <div class="vaultInfo">
                    <div class="infoBox">
                        <div>
                        <template v-if="vaultList.length>0&&!item.VaultId">
                            {{$t('base.all')}}
                        </template>
                        {{ item.EnValutName }}
                        </div>
                        <div class="text_4xl weight_700 text_blue">{{item.inWarehouse.TotalCount}}</div>
                        <div class="text_gray">{{$t('vault.TotalEstimatedValue',{n:item.inWarehouse.UsdTotalPrice})}}</div>
                    </div>
                    <div class="statsBox">
                        <a @click="navigateIfVerified({ path:`/vault/myvault/${item.VaultId}`, query:{vaultType:0} })">
                            <div>
                                <div class="text_gray">{{$t('vault.NotConsigned')}}</div>
                                <div><span class="text_4xl weight_700">{{item.NotConsigned.TotalCount}}</span> {{$t('base.items')}}</div>
                            </div>
                        </a>
                        <a @click="navigateIfVerified({ path:`/vault/myvault/${item.VaultId}`, query:{vaultType:5} })">
                            <div>
                                <div class="text_gray">{{$t('vault.Consigned')}}</div>
                                <div><span class="text_4xl weight_700">{{item.Consigned.TotalCount}}</span> {{$t('base.items')}}</div>
                            </div>
                        </a>
                        <a @click="navigateIfVerified({ path:`/vault/myvault/${item.VaultId}`, query:{vaultType:1} })">
                            <div>
                                <div class="text_gray">{{$t('vault.Listed')}}</div>
                                <div><span class="text_4xl weight_700">{{item.Listed.TotalCount}}</span> {{$t('base.items')}}</div>
                            </div>
                        </a>
                        <a @click="navigateIfVerified({ path:`/vault/myvault/${item.VaultId}`, query:{vaultType:4} })">
                            <div>
                                <div class="text_gray">{{$t('vault.SoldCards')}}</div>
                                <div><span class="text_4xl weight_700">{{item.Sold.TotalCount}}</span> {{$t('base.items')}}</div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="tag_area">
                    <a class="vault-btn tag_selling" @click="navigateIfVerified({ path: '/vault/myvault/'+item.VaultId+'?f=panel' })">
                        <span>{{$t('vault.ConsignforSale')}}</span>
                    </a>
                    <a class="vault-btn tag_pickup" @click="navigateIfVerified({ path: '/vault/Outbound/'+item.VaultId })">
                        <span>{{$t('vault.WithdrawCards')}}</span>
                    </a>
                    <a class="vault-btn tag_inware" @click="navigateIfVerified({ path: '/vault/stockinmgt/'+item.VaultId })">
                        <span>{{$t('vault.VaultHistory')}}</span>
                    </a>
                    <a class="vault-btn tag_outware" @click="navigateIfVerified({ path: '/vault/OutboundList/'+item.VaultId })">
                        <span>{{$t('vault.WithdrawalHistory')}} </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* vault 买家统计面板 */
import commonEventJs from '@/common/CommonEventJs';
import jumioVerify from '@/components/dialog/jumioVerify' //  认证弹框

import { getInfo,isVaultHouse } from "@/api/public";
const userInfo = commonEventJs.GetUserInfo() || {};
const {
    MappingUserId: MemberId = '',//'18681';国内ID
    Id: UserId = '',//'18681';海外ID
    ChineseToken: token = '',//'2f9402573be7ed49d58756f567b31991';
    TelPhone: MemberMobile = '',
    NickName: MemberRealName = '',
    MemberSource,//用户来源
    VerifyStatus
} = userInfo;


export default {
    components: {
    jumioVerify
    },
    data() {
        return {
            dislogType: this.$enumInfo.dislogType,
            loading: false,
            detail: {},
            token: token, // 用户token
            MemberId: MemberId, // 用户ID 001
            MemberSource,
            VerifyStatus,
            vaultList:[],
            allList:[],
            AccountId:'',
            inWarehouse: {},//在仓
            notWarehouse: [],//除去在仓的
        }
    },
    watch: {},
    created: function () {
        var that = this;
        that.VerifyStatus=getInfo().VerifyStatus
        that.AccountId=getInfo().AccountId
        that.MemberSource=getInfo().MemberSource
        that.MemberId=getInfo().MappingUserId
    },
    mounted: function () {
        var that = this;
        //that.GetAllValutByPage()
        that.getNewVaultStatistics()
        //that.GetVaultStatistics()//Vault统计
    },
    computed: {
        ThousandAndDecimal() {
            return function (num,fixed=2) {
                //金额千分位
                return commonEventJs.thousandAndDecimal(num,fixed);
            }
        },
    },
    methods: {
        getNewVaultStatistics(){
            const that=this
            that.loading=true;
            this.$get(this.$interface.GetVaultNewStatistics, { MemberId: that.MemberId, token: that.token,MemberSource:that.MemberSource }).then(res => {
                if(res.Result==1){
                    //类别  1在仓   2未委托   3已委托  4已上架 5已售出
                    let result=res.Data
                    let deleteIndex=''
                    let VaultStatistics=[]
                    result.forEach((val,i)=>{
                        if(val.VaultId){
                            VaultStatistics.push({AreaCode:val.AreaCode,VaultId:val.VaultId,VaultName:val.VaultName,EnValutName:val.EnValutName})
                        }
                        val.inWarehouse=val.Statistics.find(e=>e.Category==1)
                        val.NotConsigned=val.Statistics.find(e=>e.Category==2)
                        val.Consigned=val.Statistics.find(e=>e.Category==3)
                        val.Listed=val.Statistics.find(e=>e.Category==4)
                        val.Sold = val.Statistics.find(e => e.Category == 5)
                        
                        if(result.length>1&&!val.VaultId){
                            deleteIndex=i
                            
                        }
                    })
                    isVaultHouse(VaultStatistics)
                    if(deleteIndex!=null){
                        that.allList=result[deleteIndex]
                        result.splice(deleteIndex,1)
                    }
                    that.vaultList = result || [];
                    
                }
                that.loading=false
                //fun(res)
            })
        },
        navigateIfVerified(route) {
            const that=this
            
            if (this.VerifyStatus != 2) {
                this.dislogType.idverification = true;
            }else if((!that.AccountId||that.AccountId.indexOf('acct')<0)&&route.path.indexOf('panel')>0){
                var htm = `<div>${this.$t('alert.StripeAccount')}</div>`
                that.$confirm(htm, that.$t('base.hint'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: that.$t('base.GetStarted'),
                    cancelButtonText: that.$t('base.cancel'),
                }).then(() => {
                    // 前往开通跳转页面
                    that.$router.push({
                        path: '/terms/becomeseller'
                      })
                }).catch(() => { });
            } else {
                this.$router.push(route);
            }
        },
        
        closeDialog(val, bol, type) {
        let that = this;
        that.dislogType[val] = bol;
        },
        // 关闭并打开其他弹框
        openCloseDialog(openVal, closeVal, openBol, closeBol) {
        this.dislogType[openVal] = openBol;
        this.dislogType[closeVal] = closeBol;
        }
        
    }
};
</script>

<style scoped>
@import "../../../static/css/usertabslist.css";
@import "../../../static/css/vault/vaultSeller.css";

#VaultBuyerPanelBox .des_box:hover {
    box-shadow: initial;
}

.buyerPanel-side {
    margin-top: 20px;
}

.des_box>.space_between {
    border-bottom: 1px solid #E0E0E0;
}

.des_box>.space_between .desTitle {
    font-size: 14px;
}

.des_box .column {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.des_box>.space_between .num {
    font-size: 24px;
    line-height: 1em;
    margin-bottom: 12px;
}

.des_box .des_item {
    margin-top: 0 !important;
}

.buyerPanel-side .vaultSide {
    border-radius: 8px;
}

.buyerPanel-side .vaultIcon {
    width: 88px;
    height: 64px;
    display: block;
    /* background: url('../../content/img/vault/vaultIcon.png') no-repeat; */
    background: url('/static/images/vault/vaultIcon.png') no-repeat;
    background-size: cover;
}

.buyerPanel-side .worth {
    font-size: 14px;
    margin-top: 12px !important;
    margin-bottom: 12px !important;
}

.buyerPanel-side.descriptions>div>div+div {
    margin: 0;
}

.buyerPanel-side .btn-flex {
    /*justify-content: space-between;*/
    justify-content: center;
}

.buyerPanel-side .vault-btn {
    width: calc(50% - 10px);
    font-size: 16px;
    background: url('/static/images/vault/btn_w.png') no-repeat;
    background-size: contain;
    color: #fff;
    padding: 8px 0;
    text-align: center;
    cursor: pointer;
}

.buyerPanel-side .btn_b {
    background: url('/static/images/vault/btn_b.png') no-repeat !important;
    background-size: contain !important;
}

#VaultBuyerPanelBox .operateSide,
#VaultBuyerPanelBox .record-side {
    align-items: center;
    border: none;
    padding: 0;
}

#VaultBuyerPanelBox .operateSide>div {
    width: 100%
}

#VaultBuyerPanelBox .record-side .operateBtn {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-weight: bold;
}

#VaultBuyerPanelBox .operateSide .operate-side {
    width: calc(50% - 7px);
    /*(100%-14px)/2*/
    padding: 20px 12px;
    background: #fff;
    align-items: center;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
}

#VaultBuyerPanelBox .flex.space_between:first-child {
    margin-bottom: 12px;
}

#VaultBuyerPanelBox .operateSide .flex.space_between:first-child {
    margin-bottom: 16px;
}

#VaultBuyerPanelBox .operate-side i,
#VaultBuyerPanelBox .record-side i {
    width: 56px;
    height: 56px;
    display: block;
    background-size: contain;
    margin-right: 8px;
}

#VaultBuyerPanelBox .record-side {
    margin-top: 14px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    min-height: initial;
}

#VaultBuyerPanelBox .record-side>.flex {
    cursor: pointer;
    padding: 20px;
}

#VaultBuyerPanelBox .record-side>div {
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
}

#VaultBuyerPanelBox .record-side .num {
    font-weight: bold;
    font-size: 16px;
}

#VaultBuyerPanelBox .record-side .operate-side {
    align-items: center;
    font-size: 14px;
}

.sellConsignment {
    background: url('/static/images/vault/sellConsignment.png') no-repeat;
}

.pickUp {
    background: url('/static/images/vault/pickUp.png') no-repeat;
}

.inWarehouse {
    background: url('/static/images/vault/inWarehouse.png') no-repeat;
}

.outWarehouse {
    background: url('/static/images/vault/outWarehouse.png') no-repeat;
}

.notEntrusted {
    background: url('/static/images/vault/notEntrusted.png') no-repeat;
}

.entrusted {
    background: url('/static/images/vault/entrusted.png') no-repeat;
}

.shelved {
    background: url('/static/images/vault/shelved.png') no-repeat;
}

.soldOut {
    background: url('/static/images/vault/soldOut.png') no-repeat;
}




.vaultBox{
    /* border: 1px solid #e0e0e0; */
    border-radius: 12px;
    padding:24px;
    display: grid;
    grid-template-columns: auto 44%;
    gap: 6%;
    margin-top: 26px;
    padding-right: 0;
    background-repeat: no-repeat;
    background-size: contain;
    box-shadow: 0px 1px 3px #e0e0e0;
    transition: all 0.3s ease;
}

.vaultBox:hover{
    box-shadow: 0px 1px 8px #ccc;
}

.vaultInfo{    
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.vaultBox .vaultInfo+.vaultInfo{
    margin-top: 26px;
}
.infoBox{
    background: #f0f;
    min-height: 110px;
    display: flex;
    flex-direction: column;
    padding-left: 70px;
    gap: 8px;
    background: url('/static/images/vault/tag_vault.svg') -14px 58% no-repeat;
}

.statsBox{
    display: flex;
    align-items: center;
    justify-content: space-between;
}



.tag_area{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
}
.tag_area .vault-btn{    
    font-size: 16px;
    padding: 0;
    position: relative;
}
.tag_area .vault-btn::before{
    content: "";
    width: 40px;
    height: 40px;
    display: block;
    margin-bottom: 16px;
    background: url('/static/images/vault/tag_selling.svg') no-repeat;
    background-size: contain;
}
.tag_area .tag_selling::before{
    background-image: url('/static/images/vault/tag_selling.svg');
}
.tag_area .tag_pickup::before{
    background-image: url('/static/images/vault/tag_pickup.svg');
}
.tag_area .tag_inware::before{
    background-image: url('/static/images/vault/tag_inware.svg');
}
.tag_area .tag_outware::before{
    background-image: url('/static/images/vault/tag_outware.svg');
}
.stock_btn{
    background: url('/static/images/vault/btn_w.png') no-repeat;
    background-size: cover;
    color: #fff;
    padding: 9px 10px;
    border-radius: 4px;
    min-width: 100px;
    display: inline-block;
    text-align: center;
}
.stock_btn+.stock_btn{
    margin-left: 10px;
}
.vaultBuy{
    background: none;
    border:1px solid #5F6DAE;
    color: #5F6DAE;
}
.icon_flg{
    background-repeat: no-repeat;
    background-size: contain;
    padding-left: 40px;
    font-size: 15px;
}
#VaultBuyerPanelBox a{
    cursor: pointer;
}
.VaultedBox{
    display: flex;
    background: url('/static/images/vault/vaultIcon.png') no-repeat;
    background-size: contain;
    border-bottom: 1px solid #e0e0e0;
    padding: 10px;
    padding-left: 16%;
    align-items: center;
    margin-top: 35px;
}

</style>


// WEBPACK FOOTER //
// src/pages/Vault/BuyerPanel.vue